import React from 'react';
import { Stack } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import PhoneIcon from '@mui/icons-material/PhoneIphone';

import { Button } from '@occc/ui-design-system';
import { SendTestMessageController } from '@occc/feat-messaging-test';
import { TextField } from '@occc/ui-design-system';
import { EngagementChannelConfigFormValues } from '@occc/ui-notifications';

type SendTestMessageSectionComponentProps = {
  values: EngagementChannelConfigFormValues;
  type: 'sms' | 'push';
};

export const SendTestMessageSectionComponent = (props: SendTestMessageSectionComponentProps) => {
  const { values, type } = props;

  const smsBody = values.smsConfig?.isEnabled ? values.smsConfig.body : '';
  const pushNotificationTemplate = values.pushNotificationConfig?.isEnabled
    ? {
        notification: {
          title: values.pushNotificationConfig.notificationTitle,
          body: values.pushNotificationConfig.notificationBody,
        },
        data: values.pushNotificationConfig.url
          ? {
              url: values.pushNotificationConfig.url,
            }
          : null,
      }
    : null;

  return (
    <SendTestMessageController
      smsBody={type === 'sms' ? smsBody : undefined}
      pushNotificationTemplate={type === 'push' ? pushNotificationTemplate : undefined}
    >
      {(controller) => {
        return (
          <Stack spacing={2} direction='row' mb={2} alignItems='center'>
            <TextField
              value={controller.membershipUuid}
              onChange={(e) => controller.onMembershipUuidChange(e.target.value)}
              inputProps={{ maxLength: 36 }}
              label='Test Member UUID'
              sx={{ width: 504 }}
            />
            {/* Width is purposely hardcoded, so both buttons have equal size */}
            <Button
              variant='contained'
              startIcon={type === 'sms' ? <SendIcon /> : <PhoneIcon />}
              sx={{ width: 160, flexShrink: 0 }}
              disabled={type === 'sms' ? !controller.canSendTestSms : !controller.canSendTestPush}
              onClick={() => controller.sendTestMessage(type)}
            >
              Test {type === 'sms' ? 'SMS' : 'Push'}
            </Button>
          </Stack>
        );
      }}
    </SendTestMessageController>
  );
};
